import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M513.8 203.5c70 0 127 57 127 127s-57 127-127 127-127-57-127-127 56.9-127 127-127m0-64c-105.5 0-191 85.5-191 191s85.5 191 191 191 191-85.5 191-191-85.5-191-191-191zM635.3 627c83.9 0 152.2 68.3 152.2 152.2v20.4H238v-20.4c0-83.9 68.3-152.2 152.2-152.2h245.1m0-64H390.2C270.8 563 174 659.7 174 779.1v68.5c0 8.8 7.1 15.9 15.9 15.9h645.7c8.8 0 15.9-7.1 15.9-15.9v-68.5c0-119.4-96.8-216.1-216.2-216.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol